import React from 'react'
import cx from 'classnames'
import MuiCheckbox from '@mui/material/Checkbox'
import { styled } from '@mui/material/styles'
import MuiTableRow from '@mui/material/TableRow'
import MuiTableCell from '@mui/material/TableCell'
import Link from '@mui/material/Link'
import { dismissPopover } from 'services/OverlayService'
import { guardMarketsAccess } from 'helpers/marketsAccess'

const Checkbox = styled((props) => <MuiCheckbox color='default' {...props} />)({
  color: '#6288a5',
  '&.Mui-checked': {
    color: '#6288a5'
  }
})

export default ({
  deal,
  dealType,
  date,
  market,
  checked = 0,
  href,
  onSelect,
  showDealType,
  isLogged,
  hasMarketsAccess,
  setSignUpModalIsOpen,
  setUserRolesModalIsOpen
}) => {
  const handleOnClick = (e) => {
    dismissPopover(e.target)
    guardMarketsAccess(e, { isLogged, hasMarketsAccess, setSignUpModalIsOpen, setUserRolesModalIsOpen })
  }
  const isChecked = checked > 0

  return (
    <MuiTableRow
      hover={!isChecked}
      classes={{
        root: cx('bg-ghost-grey', {
          'bg-pearl-lusta': isChecked
        })
      }}
    >
      <MuiTableCell padding='checkbox' classes={{ root: 'dn-l dn-d' }}>
        <RowCheckbox {...{ checked, onSelect }} />
      </MuiTableCell>
      <MuiTableCell classes={{ root: 'min-w12 f7-m' }}>
        <Link
          className='pointer'
          href={isLogged && hasMarketsAccess ? href : null}
          onClick={handleOnClick}
        >
          {deal}
        </Link>
      </MuiTableCell>
      <MuiTableCell classes={{ root: 'f7-m' }}>
        {date}
      </MuiTableCell>
      {showDealType && (
        <MuiTableCell>
          <div className='f7-m no-wrap w-max-content'>{dealType}</div>
        </MuiTableCell>
      )}
      <MuiTableCell classes={{ root: 'dn-m' }}>{market}</MuiTableCell>
      <MuiTableCell padding='checkbox' classes={{ root: 'dn-t' }}>
        <RowCheckbox {...{ checked, onSelect }} />
      </MuiTableCell>
    </MuiTableRow>

  )
}

const RowCheckbox = ({ checked, onSelect }) => (
  <Checkbox
    checked={checked === 1}
    disabled={checked === -2}
    onChange={onSelect}
    value='checkedA'
    data-hover-popover-content={checked === -2 ? "Can't select deal of a different type" : undefined}
  />
)
